import React from 'react';
import {Tooltip} from 'primereact/tooltip';

type Props = {
    id: string,
    info: string,
}

export const CautionSign = (props: Props) => {
    return <><img id={props.id} className={'m-auto'} src={'/cautionSign.svg'} width={25} height={20}
                  style={{verticalAlign: 'middle'}}
                  data-pr-tooltip={props.info}/>
        <Tooltip target={'#' + props.id}/>
    </>;
};

export default CautionSign;
